'use client';

import React, { ReactNode } from 'react';

import classNames from 'classnames';

import { CardsSlider } from '@/blocks/components/CardsSlider';
import PossibilityCard from '@/blocks/sections/Benefits/components/possibility-card/possibility-card';

import styles from './../../styles.module.scss';

export interface SlideBlockProps {
  itemsData: { title: ReactNode; description: ReactNode; image: any }[];
}

export default function SlideBlock({ itemsData }: SlideBlockProps) {
  return (
    <div className={styles.slider}>
      <CardsSlider
        items={itemsData}
        renderCard={(card) => <PossibilityCard cardData={card} />}
        swiperProps={{ loop: false, rewind: true, spaceBetween: 8 }}
        classes={{
          slide: classNames(styles.slide, styles.bordered),
        }}
      />
    </div>
  );
}
